var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuitcaseLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7 3.90039C15.1968 3.90039 15.6 4.30359 15.6 4.80039V6.60039H20.1C20.5968 6.60039 21 7.00359 21 7.50039V19.2004C21 19.6972 20.5968 20.1004 20.1 20.1004H3.9C3.4032 20.1004 3 19.6972 3 19.2004V7.50039C3 7.00359 3.4032 6.60039 3.9 6.60039H8.4V4.80039C8.4 4.30359 8.8032 3.90039 9.3 3.90039H14.7ZM15.6 8.40039H8.4V18.3004H15.6V8.40039ZM4.8 8.40039V18.3004H6.6V8.40039H4.8ZM13.8 5.70039H10.2V6.60039H13.8V5.70039ZM17.4 8.40039V18.3004H19.2V8.40039H17.4Z",
    fill: "#2D9F75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitcaseLine);
export default __webpack_public_path__ + "static/media/suitcase-line.4138a130b41f516549881620d84445ba.svg";
export { ForwardRef as ReactComponent };